import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, Scale } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const SEL = "h-9 rounded-full border border-[#D6DBD2] px-2 text-xs font-bold";

export const DispatchSettings = ({ canEdit }) => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/admin/dispatch-settings").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return null;
  const save = (patch) => api.put("/admin/dispatch-settings", { ...c, ...patch })
    .then((r) => { setC(r.data); toast.success("Dispatch settings saved"); }).catch((e) => toast.error(errMsg(e)));
  return (
    <fieldset disabled={!canEdit} title={canEdit ? undefined : "Only admins can change this"} className="contents">
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 rounded-2xl border border-[#E3E6DD] bg-white p-3 text-sm" data-testid="dispatch-settings">
      <label className="flex flex-wrap items-center gap-2">
        <Users className="h-4 w-4 text-[#2E9E6B]" /><b className="text-[#0D3B2B]">Send each pickup to</b>
        <select value={c.batch} onChange={(e) => save({ batch: Number(e.target.value) })} className={`${SEL} disabled:opacity-50`} data-testid="dispatch-batch-select">
          {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => <option key={n} value={n}>{n} {n === 1 ? "partner" : "partners"}</option>)}
        </select>
        <span className="text-xs text-[#5B6B60]">at once · first to accept wins</span>
      </label>
      <label className="flex flex-wrap items-center gap-2">
        <Scale className="h-4 w-4 text-[#2E9E6B]" /><b className="text-[#0D3B2B]">Fair share boost</b>
        <input type="checkbox" checked={c.fair_share} onChange={(e) => save({ fair_share: e.target.checked })} className="h-4 w-4 accent-[#2E9E6B] disabled:opacity-50" data-testid="dispatch-fair-toggle" />
        <select value={c.fair_km} disabled={!c.fair_share} onChange={(e) => save({ fair_km: Number(e.target.value) })} className={`${SEL} disabled:opacity-50`} data-testid="dispatch-fair-km-select">
          {[0.5, 1, 1.5, 2, 3, 5].map((k) => <option key={k} value={k}>up to {k} km</option>)}
        </select>
        <span className="text-xs text-[#5B6B60]">partners with fewer pickups today go first</span>
      </label>
    </div>
    </fieldset>
  );
};
